import { motion } from "framer-motion";

// Scroll-reveal wrapper: staggered fade-up + slight scale.
export const Reveal = ({ children, delay = 0, className = "", y = 40 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y, scale: 0.98 }}
    whileInView={{ opacity: 1, y: 0, scale: 1 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, className = "" }) => (
  <span className={`font-mono text-xs uppercase tracking-[0.25em] text-brand-teal ${className}`}>
    {children}
  </span>
);
